import * as angular from "angular";
import type { ControlState } from "./control-state";
import template from "./string-control.html";

export interface StringControlController {
	control: ControlState;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class StringControlController implements angular.IController {
	public input: unknown;

	public $onChanges(): void {
		this.input = this.control.value;
	}

	public change(): void {
		const value = this.input === "" || this.input === null ? undefined : this.input;
		this.control.change(value);
	}
}

export default angular.module("vesl.extensions.json-schema.string-control", [])
	.component("jsonSchemaStringControl", {
		template,
		controller: StringControlController,
		bindings: { control: "<" }
	})
	.name;
